import { render } from "./BoardMeetings.vue?vue&type=template&id=ba8b3f08"
import script from "./BoardMeetings.vue?vue&type=script&lang=js"
export * from "./BoardMeetings.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/jwbpinellas/wp-content/themes/jwb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__